import React from 'react';
import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import Dialog, { DialogProps } from '@mui/material/Dialog';

const DraggablePaper = (props: PaperProps) => {
    const nodeRef = React.useRef<HTMLDivElement>(null);
    // A nested dialog is a React child of the dialog beneath it, so its drag
    // mousedown bubbles (through the portal, via React synthetic events) up to
    // the PARENT DraggablePaper — which then also starts dragging, because every
    // dialog shares the same `.draggable-dialog-title` handle and react-draggable
    // matches on the event target. Stop that bubbling here: by the time the event
    // reaches this wrapper, this dialog's own Draggable (below) has handled it.
    // Only React synthetic propagation is stopped, so native document listeners
    // (focus trap, click-away) and react-draggable's move tracking are unaffected;
    // `display: contents` leaves MUI's layout/centering of the Paper intact.
    const stopBubble = (e: React.SyntheticEvent) => e.stopPropagation();
    return (
        <div style={{ display: 'contents' }} onMouseDown={stopBubble} onTouchStart={stopBubble}>
            <Draggable nodeRef={nodeRef} handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper ref={nodeRef} {...props} />
            </Draggable>
        </div>
    );
};

export const DraggableDialog = ({ disableBackdropClick, onClose, ...props }: DialogProps & { disableBackdropClick?: boolean }) => {
    const handleClose: DialogProps['onClose'] = (event, reason) => {
        if (disableBackdropClick && reason === 'backdropClick') return;
        if (onClose) onClose(event, reason);
    };
    return <Dialog PaperComponent={DraggablePaper} onClose={handleClose} {...props} />;
};

export default DraggablePaper;
